import { RestrictHeaderMovementEnd, RestrictHeaderMovementStart } from '@/events';
export const SCROLL_TO_TARGET_HEADER = 'header';
export const SCROLL_TO_TARGET_ANCHOR_NAV = 'anchor-nav';
const getTarget = (target) => document.querySelector(`[data-scroll-to-target="${target}"]`);
/**
 * Scroll to function that accounts for site layout
 */
export function scrollTo(element, { accountForHeader, accountForAnchorNav, behavior = 'smooth' } = {}) {
    if (typeof element === undefined || element === null) {
        console.warn('scrollTo element not found');
        return;
    }
    const containerTop = typeof element === 'number' ? element : (element?.getBoundingClientRect().top ?? 0);
    const documentTop = document.documentElement.scrollTop;
    let top = containerTop + documentTop;
    if (accountForHeader) {
        top -= getTarget(SCROLL_TO_TARGET_HEADER)?.clientHeight ?? 0;
    }
    if (accountForAnchorNav) {
        top -= getTarget(SCROLL_TO_TARGET_ANCHOR_NAV)?.clientHeight ?? 0;
    }
    window.dispatchEvent(new CustomEvent(RestrictHeaderMovementStart));
    window.requestAnimationFrame(() => window.scrollTo({
        top,
        behavior,
    }));
    window.setTimeout(() => {
        window.dispatchEvent(new CustomEvent(RestrictHeaderMovementEnd));
    }, 
    // 3 seconds to account for time taken for smooth scrolling to finish.
    // No time is defined (https://drafts.csswg.org/css-overflow/#smooth-scrolling)
    // but browsers all seem to finish within this limit.
    3000);
}
